<template>
  <div class="header">
    <div class="header-box content-box">
      <!-- 左侧内容 -->
      <div class="left">
        <!-- logo -->
        <img class="logo" src="@/assets/img/logo_3.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.layout-wrap {
  min-height: 100%;
  min-width: 1200px;
}
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  font-size: 14px;
  color: #fff;
  background-color: #0085f1;

  a {
    color: #bfe2ff;
    display: inline-block;
  }

  .header-box {
    display: flex;
    align-items: center;
    width: 1200px;
    transition: left 0.3s ease-in-out;
    margin: 0 auto;
    margin-bottom: 60px;

    .left {
      flex: 1;
      display: flex;
      align-items: center;
      height: 60px;

      .logo {
        width: 237px;
        // height: 37px;
        background-size: 75px 37px;
        margin-right: 55px;
      }

      .el-menu-demo {
        background-color: #0085f1;
      }

      .nav {
        display: flex;

        li {
          a {
            display: inline-block;
            color: #bfe2ff;
            padding: 10px 23px;

            &.active {
              color: #fff;
            }

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }

    .el-menu-demo {
      .el-menu-item {
        color: #bfe2ff;
        background-color: #0085f1 !important;
      }

      .el-menu-item:hover {
        outline: 0 !important;
        color: #fff !important;
        background: #0085f1 !important;
      }

      .is-active {
        color: #fff !important;
        background: #0085f1 !important;
        a {
          color: #fff !important;
          //  background: #0085F1 !important;
        }
        .el-submenu__title {
          color: #fff !important;
          background: #0085f1 !important;
        }
      }
    }
  }

  .header-right {
    .header-user-con {
      display: flex;
      height: 60px;
      align-items: center;

      .btn-bell {
        position: relative;
        text-align: center;
        border-radius: 15px;
        top: 2px;
        padding: 0px 15px;
        cursor: pointer;

        .btn-bell-badge {
          position: absolute;
          right: 0;
          top: -6px;
          right: -8px;
          width: 27px;
          height: 17px;
          border-radius: 15px;
          background: #f56c6c;
          color: #fff;
          text-align: center;
          font-size: 12px;
          line-height: 16px;
          -webkit-transform-origin-x: 0;
          -webkit-transform: scale(0.8);
        }
      }

      .help-center {
        a {
          padding: 0px 15px;

          &:hover {
            color: #fff;
          }
        }
      }

      .user-name {
        margin-left: 15px;

        .el-dropdown-link {
          color: #bfe2ff;
          cursor: pointer;

          &:hover {
            color: #fff;
          }
        }

        .el-dropdown-menu__item {
          text-align: center;
        }
      }
    }
  }
}

.drop-item {
  a {
    color: #606266;
  }
}
</style>
<style lang="scss">
.header {
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-submenu__title {
    color: #bfe2ff !important;
  }

  .el-submenu .el-submenu__title:hover {
    outline: 0 !important;
    color: #fff !important;
    background-color: #0085f1 !important;
  }

  .el-submenu .el-submenu__title:hover i {
    color: #fff;
  }

  .el-submenu__title i {
    color: #bfe2ff;
  }

  .is-active {
    color: #fff !important;
    background: #0085f1 !important;

    .el-submenu__title {
      color: #fff !important;
      background: #0085f1 !important;
    }
  }
}
.sub-link {
  display: block;
  color: #666;
  padding: 0 10px;
}
.sub-link:hover {
  background-color: #ecf5ff;
}
.el-menu--horizontal .el-menu .el-menu-item {
  padding: 0;
}
</style>
